import React from "react"

import OutfittersCollection from "~components/shared/collections/outfitters-collection"
import COPY from "~config/copy-constants"
import { useFeaturedOutfitters } from "~utils/use-outfitters"
import LoadingOrErrorContainer from "~components/shared/todo-lib-react-components/loading-or-error-container"

interface Props {
    readonly currentOutfitterSlug: string
    readonly state: string
}

export default function RecommendedOutfitters({
    currentOutfitterSlug,
    state,
}: Props) {
    const { outfitters, isLoading, error } = useFeaturedOutfitters({
        state: state,
    })

    const outfittersWithoutCurrent = outfitters.filter(
        (outfitter) => outfitter.slug !== currentOutfitterSlug
    )

    if (!outfittersWithoutCurrent.length) return null

    return (
        <LoadingOrErrorContainer
            isLoading={isLoading}
            error={error}
            shouldRenderChildren={!isLoading && !error}
        >
            <OutfittersCollection
                label={`${COPY.EXPLORE_OTHER_OUTFITTERS_IN} ${state}`}
                outfitters={outfittersWithoutCurrent}
                isLoading={isLoading}
            />
        </LoadingOrErrorContainer>
    )
}
